import { render } from "./Dialog.vue?vue&type=template&id=080a29e7"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=080a29e7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__